/**
 * Create Chat Page - Main component for creating new chats
 * Implements the complete chat creation flow in a single page
 */

import { Card, CardBody } from '@heroui/react';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import { CreateChatForm } from './components/CreateChatForm';
import { CreateChatHeader } from './components/CreateChatHeader';

export const CreateChat: React.FC = () => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate('/chats');
  };

  return (
    <>
      <Helmet>
        <title>Create Chat - Choco Admin</title>
      </Helmet>
      <div className="p-6 min-h-screen bg-background">
        <div className="max-w-6xl mx-auto space-y-6">
          <CreateChatHeader />

          <Card className="shadow-lg">
            <CardBody className="p-8">
              <CreateChatForm onCancel={handleCancel} />
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};
